/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { ACK_OUTBOX_STORAGE_KEY, clearAppCommandAcks } from './appCommands/acks';
import { ACTIVE_AT_STORAGE_KEY } from './conversationRecency';
import { agentWorkspaceStore, WORKSPACE_STORAGE_PREFIX } from './workspace/agentWorkspaceStore';

/** This browser tab's active conversation (sessionStorage). */
export const AGENT_CONVERSATION_ID_STORAGE_KEY = 'agent-conversation-id';
/** Which turns of each conversation this tab has seen, for unread markers (sessionStorage). */
export const SEEN_TURNS_STORAGE_KEY = 'agent-conversation-seen-turns';
const OWNER_STORAGE_KEY = 'agent-session-owner';

const ACCOUNT_KEYS = new Set([
  AGENT_CONVERSATION_ID_STORAGE_KEY,
  ACTIVE_AT_STORAGE_KEY,
  ACK_OUTBOX_STORAGE_KEY,
  SEEN_TURNS_STORAGE_KEY,
  OWNER_STORAGE_KEY,
]);

/**
 * Forgets the Agent data this tab keeps for the signed-in account: the active conversation, its
 * recency, which turns were seen, pending app-command acks and cached workspaces. sessionStorage
 * outlives the logout redirect, so without this the next account in the tab could reopen the
 * previous one's content.
 */
export const clearAgentTabSession = () => {
  for (const key of Object.keys(sessionStorage)) {
    if (ACCOUNT_KEYS.has(key) || key.startsWith(WORKSPACE_STORAGE_PREFIX))
      sessionStorage.removeItem(key);
  }
  agentWorkspaceStore.reset();
  clearAppCommandAcks();
};

/**
 * Records `account` as the owner of this tab's Agent data, first clearing data another account
 * left behind. Returns whether anything was cleared.
 */
export const claimAgentTabSession = (account: string | undefined) => {
  if (!account) return false;
  const owner = sessionStorage.getItem(OWNER_STORAGE_KEY);
  const cleared = owner !== null && owner !== account;
  if (cleared) clearAgentTabSession();
  sessionStorage.setItem(OWNER_STORAGE_KEY, account);
  return cleared;
};
